const translateLegacyStatus = (status: string): string => {
    const translations = {
        all: 'Alle open',
        new: 'Nieuw',
        appointment: 'Afspraak ingepland',
        proposal: 'Voorstel verzonden',
        'on-hold': 'Geparkeerd',
        pending: 'In behandeling',
        unreachable: 'Niet bereikbaar',
        open: 'Open',
        successful: 'Gewonnen',
        processed: 'Kans',
        closed: 'Verloren',
    };

    return translations[status];
};

const translateLegacyStatusReason = (statusReason: string): string => {
    const translations = {
        migrated: 'Migratie vanuit Just',
        'waiting-internal': 'Wacht op intern',
        'waiting-external': 'Wacht op extern',
        'waiting-contact': 'Wacht op lead',
        information: 'Wil meer informatie',
        'negative-advice': 'Negatief advies',
        'no-suitable-time': 'Komt niet uit',
        'no-time': 'Voorlopig geen tijd van lead',
        'not-interested': 'Geen interesse',
        other: 'Overig',
        thinking: 'Denkt er over na',
        'to-competitor': 'Naar concurrent',
        voicemail: 'Voicemail',
        withdrawn: 'Lead trekt zich terug',
        'wrong-contact': 'Niet juiste persoon',
        'wrong-contact-details': 'Contactgegevens kloppen niet',
        reopened: 'Opnieuw geopend',
        unreachable: 'Nooit kunnen bereiken',
        'long-term': 'Lange termijn',
        'contacted-per-email': 'Per e-mail contact gezocht',
        'waiting-new-build': 'Wacht op nieuwbouw',
        'processed-reopened': 'Kans beoordeeld - Oppakken',
        'processed-closed': 'Kans beoordeeld - Niet oppakken',
        'auto-closed': 'Automatisch gesloten',
    };

    return translations[statusReason];
};

export {
    translateLegacyStatus,
    translateLegacyStatusReason,
};
